import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\AvailabilityItem\DeleteAvailabilityItemController::deleteMethod
* @see app/Http/Controllers/AvailabilityItem/DeleteAvailabilityItemController.php
* @route '/api/unavailability/items/{availability_item}'
*/
export const deleteMethod = (args: { availability_item: string | number | { id: string | number } } | [availability_item: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

deleteMethod.definition = {
    methods: ["delete"],
    url: '/api/unavailability/items/{availability_item}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\AvailabilityItem\DeleteAvailabilityItemController::deleteMethod
* @see app/Http/Controllers/AvailabilityItem/DeleteAvailabilityItemController.php
* @route '/api/unavailability/items/{availability_item}'
*/
deleteMethod.url = (args: { availability_item: string | number | { id: string | number } } | [availability_item: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { availability_item: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { availability_item: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            availability_item: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        availability_item: typeof args.availability_item === 'object'
        ? args.availability_item.id
        : args.availability_item,
    }

    return deleteMethod.definition.url
            .replace('{availability_item}', parsedArgs.availability_item.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\AvailabilityItem\DeleteAvailabilityItemController::deleteMethod
* @see app/Http/Controllers/AvailabilityItem/DeleteAvailabilityItemController.php
* @route '/api/unavailability/items/{availability_item}'
*/
deleteMethod.delete = (args: { availability_item: string | number | { id: string | number } } | [availability_item: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\AvailabilityItem\DeleteAvailabilityItemController::undo
* @see app/Http/Controllers/AvailabilityItem/DeleteAvailabilityItemController.php
* @route '/api/unavailability/items/{availability_item}/undo-delete'
*/
export const undo = (args: { availability_item: string | number } | [availability_item: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

undo.definition = {
    methods: ["get","head"],
    url: '/api/unavailability/items/{availability_item}/undo-delete',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AvailabilityItem\DeleteAvailabilityItemController::undo
* @see app/Http/Controllers/AvailabilityItem/DeleteAvailabilityItemController.php
* @route '/api/unavailability/items/{availability_item}/undo-delete'
*/
undo.url = (args: { availability_item: string | number } | [availability_item: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { availability_item: args }
    }

    if (Array.isArray(args)) {
        args = {
            availability_item: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        availability_item: args.availability_item,
    }

    return undo.definition.url
            .replace('{availability_item}', parsedArgs.availability_item.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\AvailabilityItem\DeleteAvailabilityItemController::undo
* @see app/Http/Controllers/AvailabilityItem/DeleteAvailabilityItemController.php
* @route '/api/unavailability/items/{availability_item}/undo-delete'
*/
undo.get = (args: { availability_item: string | number } | [availability_item: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AvailabilityItem\DeleteAvailabilityItemController::undo
* @see app/Http/Controllers/AvailabilityItem/DeleteAvailabilityItemController.php
* @route '/api/unavailability/items/{availability_item}/undo-delete'
*/
undo.head = (args: { availability_item: string | number } | [availability_item: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: undo.url(args, options),
    method: 'head',
})

const DeleteAvailabilityItemController = { deleteMethod, undo, delete: deleteMethod }

export default DeleteAvailabilityItemController